import { createSlice } from '@reduxjs/toolkit';

const userAuditSlice = createSlice({
  name: 'userAudit',
  initialState: {
    userAudits: [],
    loading: false,
    error: null,
    reportStatus: null, // Track the report submission status
  },
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setUserAudits: (state, action) => {
      state.userAudits = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    submitReport: (state) => {
      // Handle the report submission logic here
      state.reportStatus = 'submitted'; // Example: Set status to 'submitted'
    },
    resetReportStatus: (state) => {
      // Reset the report status to null or any default value
      state.reportStatus = null;
    },
  },
});

export const { setLoading, setUserAudits, setError, submitReport, resetReportStatus } = userAuditSlice.actions;
export default userAuditSlice.reducer;
